export var Paths;

(function (Paths) {
  Paths["List"] = "/channels";
  Paths["Show"] = "/channels/:channelSlug";
  Paths["ListVideos"] = "/channels/:channelSlug/videos";
  Paths["FindVideoIndex"] = "/channels/:channelSlug/video_index";
  Paths["ListEditions"] = "/channels/:channelSlug/editions";
  Paths["ShowEdition"] = "/channels/:channelSlug/editions/:editionSlug";
  Paths["ListEditionVideos"] = "/channels/:channelSlug/editions/:editionSlug/videos";
  Paths["FindEditionVideoIndex"] = "/channels/:channelSlug/editions/:editionSlug/video_index";
  Paths["ListEditionPlaylists"] = "/channels/:channelSlug/editions/:editionSlug/playlists";
  Paths["ShowEditionPlaylist"] = "/channels/:channelSlug/editions/:editionSlug/playlists/:playlistSlug";
  Paths["ListEditionPlaylistVideos"] = "/channels/:channelSlug/editions/:editionSlug/playlists/:playlistSlug/videos";
  Paths["FindEditionPlaylistVideoIndex"] = "/channels/:channelSlug/editions/:editionSlug/playlists/:playlistSlug/video_index";
  Paths["ListFeatured"] = "/channels/featured";
})(Paths || (Paths = {}));